import * as React from "react";
const SvgFiRrCupTogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 5h-.283l-.381-1.82A4.02 4.02 0 0 0 17.42 0H6.58a4.02 4.02 0 0 0-3.915 3.18L2.284 5h-.283a1 1 0 0 0 0 2h.204l1.464 12.578A5 5 0 0 0 8.635 24h6.729a5 5 0 0 0 4.966-4.422L21.794 7H22a1 1 0 0 0 0-2M4.8 12h14.399l-.582 5H5.382zM6.58 2h10.841c.941 0 1.765.668 1.958 1.59L19.674 5H4.326l.295-1.41A2.01 2.01 0 0 1 6.58 2m13.201 5-.349 3H4.567l-.349-3zm-4.417 15H8.635a3 3 0 0 1-2.98-2.653L5.615 19h12.77l-.04.347A3 3 0 0 1 15.364 22"
    />
  </svg>
);
export default SvgFiRrCupTogo;
